import axios from 'axios';
import { supabase } from './supabaseClient';

// ✅ Create ONE axios instance with base URL
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL
});

// 1) Fetch metadata
export const fetchMetadata = async (collection, tokenId) => {
  try {
    const { data } = await api.get('/api/', {
      params: { action: 'metadata', collection, tokenId }
    });
    return data;
  } catch (err) {
    console.error(`Error fetching metadata for ${collection}#${tokenId}:`, err);
    return null;
  }
};

// 2) Fetch owned NFTs
export const fetchOwnedNFTs = async (walletAddress) => {
  try {
         const { data: { tokens = [] } } = await api.get('/api/nft', {
           params: { action: 'owned-nfts', address: walletAddress }
         });

    const enriched = await Promise.all(tokens.map(async token => {
      const meta = await fetchMetadata(token.collection, token.tokenId) || {};
      return {
        ...token,
        attributes: Array.isArray(meta.attributes) ? meta.attributes : []
      };
    }));

    return enriched;
  } catch (error) {
    console.error("Error fetching owned NFTs:", error);
    return [];
  }
};

// 3) Check if admin (using Supabase — no change)
export const checkIfAdmin = async (walletAddress) => {
  try {
    const { data, error } = await supabase
      .from('admin_wallets')
      .select('*')
      .eq('wallet_address', walletAddress.toLowerCase());
    if (error) {
      console.error('Error checking admin status:', error);
      return false;
    }
    return data.length > 0;
  } catch (err) {
    console.error('Error in checkIfAdmin:', err);
    return false;
  }
};

// 4) Fetch approved collections
export const fetchApprovedCollections = async () => {
  try {
    const response = await api.get('/api/admin', {
      params: { action: 'collections' }
    });
    return response.data.collections;
  } catch (error) {
    console.error("Error fetching collections:", error);
    return [];
  }
};

// ✅ NEW: Post user stats to leaderboard (fixed to use action=update)
export const postUserStats = async (payload) => {
  try {
    const response = await api.post('/api/stats?action=update', payload, {
      headers: {
        'x-api-access': 'leaderboard-access-2025'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error posting user stats:', error);
    return null;
  }
};
